package com.nnod.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable

@Composable
fun NnodTheme(
    darkTheme: Boolean = false,
    content: @Composable () -> Unit,
) {
    val colorScheme = if (darkTheme) NnodDarkColorScheme else NnodLightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        typography = nnodTypography(),
        shapes = NnodShapes,
        content = content,
    )
}
